
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-parlor/[companyname]",
      function () {
        return require("private-next-pages/gangwon-parlor/[companyname]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-parlor/[companyname]"])
      });
    }
  